export default __webpack_public_path__ + "static/2-5d3f3262fdb5caaedd2b312daaec0735.png";